import { createSlice } from "@reduxjs/toolkit";

export const kanbanSlice = createSlice({
	name: "kanban",
	initialState: {
		showDetail: false,
		detailKanban: null,
	},
	reducers: {
		handleShowDetail: (state, { payload: values }) => ({
			...state,
			showDetail: true,
			detailKanban: values,
		}),
		handleCloseDetail: (state) => ({
			...state,
			showDetail: false,
		}),
	},
});
export const { handleShowDetail, handleCloseDetail } = kanbanSlice.actions;
export default kanbanSlice.reducer;
